/**
 * Shared decorative SVG pieces for the consumer look: wavy section dividers
 * and hand-drawn squiggle underlines. Pure presentation, no logic.
 */

/**
 * A wavy divider to melt one color block into the next. Place at the top or
 * bottom of a full-bleed section and set `fill` to the NEIGHBOURING section's
 * background so the wave appears to bite into this one.
 */
export function Wave({
  fill = "#FFF6EC",
  flip = false,
  className = "",
}: {
  fill?: string;
  flip?: boolean;
  className?: string;
}) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 1440 96"
      preserveAspectRatio="none"
      className={`block h-12 w-full sm:h-16 ${flip ? "rotate-180" : ""} ${className}`}
    >
      <path
        d="M0,48 C160,88 320,16 480,32 C640,48 800,88 960,72 C1120,56 1280,24 1440,48 L1440,96 L0,96 Z"
        fill={fill}
      />
    </svg>
  );
}

/** A hand-drawn squiggly underline to sit beneath a heading word. */
export function Squiggle({
  stroke = "#FFC93C",
  className = "",
}: {
  stroke?: string;
  className?: string;
}) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 220 24"
      fill="none"
      className={`block h-4 w-40 sm:w-52 ${className}`}
      preserveAspectRatio="none"
    >
      <path
        d="M4 17 C 30 6, 58 5, 82 13 S 132 22, 158 12 S 200 4, 216 11"
        stroke={stroke}
        strokeWidth="7"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** A small starburst/spark shape for playful accents next to headings. */
export function Spark({
  fill = "#FFC93C",
  className = "",
}: {
  fill?: string;
  className?: string;
}) {
  return (
    <svg aria-hidden viewBox="0 0 40 40" className={`block h-8 w-8 ${className}`}>
      <path
        d="M20 0 L24.5 15.5 L40 20 L24.5 24.5 L20 40 L15.5 24.5 L0 20 L15.5 15.5 Z"
        fill={fill}
        stroke="#0F2240"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
